export default { sha: '88e694abaa9b345c18fbcf7ad4462629b7ee3031', buildNumber: 'undefined' }
